import React, { Component } from 'react';
import Profilecomponent from '../../common/profilecomponent';
import GastoCorrienteContainer from './GastoCorrienteContainer';
import SweetAlert from 'sweetalert2-react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { TabContent, TabPane, Nav, NavLink, NavItem } from "reactstrap";
import classnames from 'classnames';
import Dropzone from '../../common/DropzoneExample';

import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';

import { Link } from "react-router-dom";


const mapStateToProps = (state) => {

	state.GastoCorrienteReducer.getResponDataGC = false;
	state.GastoCorrienteReducer.errorResponDataGC = false;
	state.GastoCorrienteReducer.getGCBorrar = false;
	state.GastoCorrienteReducer.errorGCBorrar = false;

	return {
		getResponDataGC: state.GastoCorrienteReducer.getResponDataGC,
		errorResponDataGC: state.GastoCorrienteReducer.errorResponDataGC,
		getGCBorrar: state.GastoCorrienteReducer.getGCBorrar,
		errorGCBorrar: state.GastoCorrienteReducer.errorGCBorrar
	};
};


class GastoCorriente extends Component {

	constructor(props) {
		super(props);
		this.state = {
			activeTab: 1,
			show: false,
		};
	}

	render() {
		const { activeTab } = this.state
		return (
			<>
				<div className="section-body">
					<div className="container-fluid">
						<div className="d-flex justify-content-between align-items-center ">
							<div className="header-action">
								<h1 className="page-title">Gastos</h1>
								<ol className="breadcrumb page-breadcrumb">
									<li className="breadcrumb-item"><a href="#">Registro De Gastos</a></li>
									<li className="breadcrumb-item active" aria-current="page">Listado Por Usuario</li>
								</ol>
							</div>
							<Nav tabs className="page-header-tab">

								<NavItem>
									<Link
										to={"/creargastocorriente"}
										className={classnames({ active: activeTab === 3 })}
										onClick={() => this.setState({ activeTab: 3 })}
									>
										Agregar
    								</Link>
								</NavItem>

							</Nav>

						</div>
					</div>
				</div>

				<div className="section-body mt-4">
					<div className="container-fluid">
						<TabContent activeTab={activeTab}>

							<TabPane tabId={1} className={classnames(['fade show'])}>
								<GastoCorrienteContainer />
							</TabPane>

						</TabContent>
					</div>
				</div>

			</>
		);

	}//END RENDER


}//END CLASS

export default withRouter(connect(mapStateToProps, null)(GastoCorriente));

